module.exports = __webpack_public_path__ + "img/b_9_s.b24c5e34.jpg";